"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureText = void 0;
var toFontProperty_1 = require("./toFontProperty");
exports.measureText = function (text, canvas) {
    var ctx = canvas.getContext("2d");
    ctx.save();
    ctx.font = toFontProperty_1.toFontProperty(text);
    var metrics = ctx.measureText(text.content);
    ctx.restore();
    var computedHeight = metrics.fontBoundingBoxAscent && metrics.fontBoundingBoxDescent
        ? metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent
        : text.fontSize * 1.2;
    return {
        width: metrics.width * 1.1,
        height: computedHeight
    };
};
//# sourceMappingURL=measureText.js.map